import { Component, OnInit } from '@angular/core';
import { ToastMessageConfig, ToastService } from './toast.service';

@Component({
  selector: 'cm-toast-message',
  templateUrl: './toast-message.component.html',
  styleUrls: ['./toast-message.component.scss'],
})
export class ToastMessageComponent implements OnInit {
  public toastMessages;

  constructor(private toastService: ToastService) {}

  ngOnInit() {
    this.toastMessages = this.toastService.data;
  }

  public clearTimeout(toastId: number): void {
    this.toastService.clearTimeout(toastId);
  }

  public close(toast: ToastMessageConfig, event?: MouseEvent): void {
    if (event) {
      event.preventDefault();
    }
    if (!toast.ttl || toast.ttl === 0) {
      this.toastService.remove(toast.id);
    }
  }

  onMouseOver(toast: ToastMessageConfig) {
    toast.ttl = 0;
    clearTimeout(toast.id);
  }

  onMouseOut(toast: ToastMessageConfig, event?: MouseEvent) {
    if (toast.ttl === 0) {
      this.close(toast, event);
    }
  }
}
